import { VIEWPORT, VIEWPORT_BREAKPOINT } from 'constants';

export default function getViewport(width) {
  return Object.keys(VIEWPORT).find(
    (viewportName) => width < VIEWPORT_BREAKPOINT[viewportName]
  );
}
